<template>
  <el-header height="64px" class="pcFromHead">
    <div class="banner-row">
      <div class="comAndList">
        <h1 class="logo">
          <span class="logo-bg">
            <img :src="logoSrc" alt="logo" />
          </span>
          <span class="logo-text">
            {{ sysName }}
          </span>
        </h1>
        <comSelect></comSelect>
        <userMsg></userMsg>
      </div>
      <div class="menuList">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          :active-text-color="acColor"
          :popper-append-to-body="patd"
          @select="handleSelect"
        >
          <template v-for="(item, index) in menuData">
            <template v-if="item.children && item.children.length > 0">
              <el-submenu
                :key="index"
                :index="item.path"
                :show-timeout="sHTime"
                :hide-timeout="sHTime"
              >
                <template slot="title">
                  <template v-if="item.type == 'text'">
                    {{ item.name }}
                  </template>
                  <template v-else>
                    <span class="tAddi">
                      <img :src="item.imgPath" alt="" />
                      <span>{{ item.name }}</span>
                    </span>
                  </template>
                  <span
                    v-if="Number(index) != menuData.length - 1"
                    class="vLine"
                  ></span>
                </template>
                <el-menu-item
                  v-for="(item2, index2) in item.children"
                  :key="index2"
                  :index="item2.path"
                >
                  <template v-if="item2.type == 'text'">
                    {{ item2.name }}
                  </template>
                  <template v-else>
                    <span class="tAddi">
                      <img :src="item2.imgPath" alt="" />
                      <span>{{ item2.name }}</span>
                    </span>
                  </template>
                </el-menu-item>
              </el-submenu>
            </template>
            <template v-else>
              <el-menu-item :key="index" :index="item.path">
                <template v-if="item.type == 'text'">
                  {{ item.name }}
                </template>
                <template v-else>
                  <span class="tAddi">
                    <img :src="item.imgPath" alt="" />
                    <span>{{ item.name }}</span>
                  </span>
                </template>
                <span
                  v-if="Number(index) != menuData.length - 1"
                  class="vLine"
                ></span>
              </el-menu-item>
            </template>
          </template>
        </el-menu>
      </div>
    </div>
  </el-header>
</template>
<script>
import comSelect from "@/components/pcFrom/comSelect.vue";
import userMsg from "@/components/pcFrom/userMsg.vue";
export default {
  props: {
    logoSrc: String,
    sysName: String,
    acColor: String,
    menuData: Array
  },
  data() {
    return {
      activeIndex: "", // 动态，根据地址反查
      sHTime: 100,
      patd: false,
      lv2ActiveList: ["/rhqy/accout/view"] // head二级地址激活特殊处理
    };
  },
  watch: {
    $route(to) {
      this.initActiveIndex(to.path);
    }
  },
  components: { comSelect, userMsg },
  async mounted() {},
  methods: {
    handleSelect(index) {
      if (index != null && index.toString().length > 0) {
        if (index == "/rhqy/accout/logout") {
          this.$common
            .http({
              url: "/api/authorize/logout",
              data: {}
            })
            .then(() => {
              this.$router.push("/rhqy/login");
            });
        } else {
          this.$router.push(index);
        }
      }
    },
    initActiveIndex(path) {
      // console.log(path);
      const pathArray = path.split("/");
      this.activeIndex = "/" + pathArray[1] + "/" + pathArray[2];
      // 头部二级地特殊处理
      if (this.lv2ActiveList.indexOf(path) >= 0) {
        this.activeIndex = path;
      }
    }
  },
  created() {
    this.initActiveIndex(this.$route.path);
  }
};
</script>
<style scoped lang="less">
@defaultHeight: 64px;
@defaultWidth: 100%;
@menuFontSize: 18px;

.pcFromHead {
  // padding: 0 50px;
  width: 100%;
  background: #ffffff;
  height: @defaultHeight;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.13);
  display: flex;
  align-items: center;
  justify-self: center;
  .banner-row {
    width: @defaultWidth;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-self: center;
    justify-content: space-between;
    overflow: hidden;
  }
  .comAndList {
    display: flex;
    align-items: center;
  }
  .logo {
    display: flex;
    align-items: center;
  }
  h1 {
    margin: 0;
  }
  .logo-bg img {
    // height: calc(@defaultHeight - 20px);
    // height: @defaultHeight;
    height: 35px;
    display: flex;
    align-items: center;
    margin-right: 5px;
  }
  .logo-text {
    font-size: 20px;
    display: inline-block;
    vertical-align: 24px;
    font-weight: normal;
  }
  .el-menu-item,
  .el-submenu,
  .el-submenu__title,
  .el-menu.el-menu--horizontal {
    border-bottom: none !important;
    font-size: @menuFontSize !important;
  }
  .vLine {
    position: absolute;
    right: 0;
    top: calc(50% - 12px);
    width: 2px;
    height: 24px;
    background: #eaeaea;
  }
  .tAddi {
    display: inline-block;
    line-height: 60px;
    span {
      display: inline-block;
      position: relative;
      top: -3px;
    }
    img {
      padding-right: 5px;
      display: inline-block;
      position: relative;
      top: -2px;
    }
  }
  .el-menu-demo {
    li:last-child {
      padding-right: 0 !important;
      .el-submenu__title {
        padding-right: 0 !important;
      }
    }
  }
  .el-menu-item {
    color: #303133;
  }
  .el-menu--horizontal > .el-menu-item,
  .el-menu--horizontal .el-menu .el-menu-item,
  .el-menu--horizontal .el-menu .el-submenu__title {
    color: #303133;
  }
}
</style>
<style scoped lang="less">
.pcFromHead {
  .el-menu--horizontal > .el-submenu .el-submenu__title {
    border: none !important;
  }
}
.el-menu-item {
  color: #303133;
}
</style>
